module.exports = "<div>\n    <iframe style=\"width: 100%; height: 1000px; border: 0; margin: 0; padding: 0;\" [src]=\"urlMarina\"></iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/tickets.component.html
// module id = 1004
// module chunks = 7